/**
 * Type representing an opaque value.
 */
export class AnyType {
  read(_cx, _reader, raw) {
    return {
      ok: true,
      value: raw
    };
  }
  write(writer, value) {
    return writer.writeAny(value);
  }
  test(_cx, value) {
    return {
      ok: true,
      value: value
    };
  }
  equals(val1, val2) {
    return val1 === val2;
  }
  clone(value) {
    return value;
  }
}
export const $Any = new AnyType();
